import React, { PropTypes } from 'react';
import './loadable.scss';

const Loading = ({ size, visible, message, fixed }) => {
  let wrapperClass = 'loading-wrapper';

  wrapperClass += ' loading-' + size;

  if (fixed) {
    wrapperClass += ' loading-wrapper-fixed';
  }

  return (
    <div className={wrapperClass}>
      <div className="loading-img-wrapper">
        <img className="loading-img" src={`${window.TPSOUTHCONE_STATIC_ASSETS_BASE_PUBLIC_URL || ''}static/images/loading.gif`} />
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
}

Loading.propTypes = {
  size: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  fixed: PropTypes.bool
};


export default function ({
  fixed = false,
  loadingProp = 'loading',
  loadingMessageProp = 'loadingMessage',
  size = 'large'
} = {}) {
  return Component => {
    let augmentedPropTypes = {
      ...Component.propTypes,
    };
    augmentedPropTypes[loadingProp] = PropTypes.bool.isRequired;

    return class Loadable extends Component {
      static displayName = Component.displayName || Component.name;
      static propTypes = augmentedPropTypes;
      loading(overrideSize, force) {
        return (force || !!this.props[loadingProp]) ? (
          <Loading
            size={overrideSize || size}
            message={this.props[loadingMessageProp] || ''}
            fixed={fixed}
          />
        ) : undefined;
      }
    };
  };
}



// WEBPACK FOOTER //
// ./components/lib/Loadable/index.js